/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbConseillerPedagogiqueGridDto } from './FcbConseillerPedagogiqueGridDto';
import {
    FcbConseillerPedagogiqueGridDtoFromJSON,
    FcbConseillerPedagogiqueGridDtoFromJSONTyped,
    FcbConseillerPedagogiqueGridDtoToJSON,
} from './FcbConseillerPedagogiqueGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbConseillerPedagogiqueGridDtoPaginatedResults
 */
export interface FcbConseillerPedagogiqueGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbConseillerPedagogiqueGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbConseillerPedagogiqueGridDto>}
     * @memberof FcbConseillerPedagogiqueGridDtoPaginatedResults
     */
    results?: Array<FcbConseillerPedagogiqueGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbConseillerPedagogiqueGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbConseillerPedagogiqueGridDtoPaginatedResults interface.
 */
export function instanceOfFcbConseillerPedagogiqueGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbConseillerPedagogiqueGridDtoPaginatedResultsFromJSON(json: any): FcbConseillerPedagogiqueGridDtoPaginatedResults {
    return FcbConseillerPedagogiqueGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbConseillerPedagogiqueGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbConseillerPedagogiqueGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbConseillerPedagogiqueGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbConseillerPedagogiqueGridDtoPaginatedResultsToJSON(value?: FcbConseillerPedagogiqueGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbConseillerPedagogiqueGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

